import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import { serializeRtkQueryError } from 'util/rtkQueryError';

export const TENANT_DASHBOARD_TAGS = {
  METRICS: 'TenantDashboardMetrics'
};

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: [TENANT_DASHBOARD_TAGS.METRICS]
});

export const tenantDashboardApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    getDashboardNotaries: build.query({
      async queryFn({ startDate, endDate, locationGuid }) {
        try {
          const res = await api.TenantDashboard.notaries({
            startdate: startDate,
            enddate: endDate,
            locationGuid
          });
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      providesTags: [{ type: TENANT_DASHBOARD_TAGS.METRICS, id: 'NOTARIES' }]
    }),

    getDashboardJournals: build.query({
      async queryFn({ startDate, endDate, locationGuid }) {
        try {
          const res = await api.TenantDashboard.journals({
            startdate: startDate,
            enddate: endDate,
            locationGuid
          });
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      providesTags: [{ type: TENANT_DASHBOARD_TAGS.METRICS, id: 'JOURNALS' }]
    }),

    getDashboardNotarizations: build.query({
      async queryFn({ startDate, endDate, locationGuid }) {
        try {
          const res = await api.TenantDashboard.notarizations({
            startdate: startDate,
            enddate: endDate,
            locationGuid
          });
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      providesTags: [
        { type: TENANT_DASHBOARD_TAGS.METRICS, id: 'NOTARIZATIONS' }
      ]
    }),

    getDashboardLocations: build.query({
      async queryFn() {
        try {
          const res = await api.TenantDashboard.locations();
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      providesTags: [{ type: TENANT_DASHBOARD_TAGS.METRICS, id: 'LOCATIONS' }]
    }),

    getDashboardConnectionRequests: build.query({
      async queryFn({ startDate, endDate, locationGuid }) {
        try {
          const res = await api.TenantDashboard.connectionRequests({
            startdate: startDate,
            enddate: endDate,
            locationGuid
          });
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      providesTags: [
        { type: TENANT_DASHBOARD_TAGS.METRICS, id: 'CONNECTION_REQUESTS' }
      ]
    })
  })
});

export const {
  useGetDashboardNotariesQuery,
  useGetDashboardJournalsQuery,
  useGetDashboardNotarizationsQuery,
  useGetDashboardLocationsQuery,
  useGetDashboardConnectionRequestsQuery
} = tenantDashboardApi;
